import React, { useState, useEffect } from "react";
import { mapProperties } from "colbi_web_ui/lib/utils";
import {
    filteredQueriesByModules,
    filteredQueriesByModulesForMenu,
    getFirstModuleOfArray,
} from "../../routes/manageRouting";
import { hydrateRoute, urlRedirectLink } from "../../utils/routingUtils";
import { BuildSovosNavProps, decodeUserSession } from "../../utils/utils";
import LoadingPage from "../Login/LoadingPage";
import GlobalLayout from "../../components/GlobalLayout/GlobalLayout";
import {
    SovosBox,
    SovosCircularProgress,
    SovosPageContentGeneric,
    SovosPageLayout,
} from "mosaic-react";
import { RepositoryStatus } from "../../components";
import FileInformationSelection from "colbi_web_ui/lib/components/layout/FileInformationSelection/FileInformationSelection";
import Connect from "colbi_web_ui/lib/components/Connect";
import { LoadingIndicator } from "colbi_web_ui/lib/components";
import MainTabs from "../App/MainTabs/MainTabs";
import { renderRoutes } from "react-router-config";
import { useAuth } from "react-oidc-context";
import I18n from "../../I18n";

import { mapPropertiesForMenu } from "../../utils";
import { parse } from "query-string";
import { filteredNavigationByModulesForNestedLinks } from "../Repository/navigation";

/**
 * Controller folder utils
 * Built to make controller code less repeatable and lex complex to understand
 * */

// similar to getQueryResults but for array of queryNames
export const getQueryResultsArray = (fetchResults, queryNamesArray) => {
    return queryNamesArray.reduce((acc, { resultName, queryName }) => {
        acc[resultName] = fetchResults[queryName];
        return acc;
    }, {});
};

export const userSessionInfo = (user) => decodeUserSession(user);

export const appRedirectValidations = (params) => {
    const {
        redirect,
        projectId,
        locale,
        fiscalYear,
        importId,
        fiscalYears,
        appContext,
        match,
        matchParams,
        importIdToUse,
        firstModuleFromProject,
        section,
        fileType,
    } = params || {};

    if (redirect) {
        return redirect;
    }

    if (!projectId) {
        return urlRedirectLink(`${locale ? `/${locale}` : ""}/`);
    }

    if (!fiscalYear && !importId && !fiscalYears.length) {
        return urlRedirectLink(
            `${locale ? `/${locale}` : "/en"}/${projectId}/0000/full/repository/activity`,
        );
    }

    if (
        fiscalYear &&
        importId &&
        fiscalYears.length &&
        appContext === "repository" &&
        !(match?.url || "").match("\\d+/\\d+/\\d+/repository") &&
        !(match?.url || "").match("\\d+/\\d+/full/repository")
    ) {
        return urlRedirectLink(
            `${locale ? `/${locale}` : "/en"}/${projectId}/${fiscalYear}/${importId}/repository/${section}${fileType ? "/" + fileType : ""}`,
        );
    }

    if (fiscalYear === "0000" && fiscalYears.length) {
        const to = hydrateRoute(match.path, {
            ...matchParams,
            fiscalYear: Math.max(...fiscalYears),
            importId: importIdToUse,
            firstModuleFromProject,
        });

        if (to !== match.url && !to.match(/\*$/)) {
            return urlRedirectLink(to);
        }
    }

    if (
        fiscalYear &&
        importIdToUse &&
        !isNaN(Number(matchParams.fiscalYear)) &&
        !isNaN(Number(matchParams.importId)) &&
        fiscalYear !== matchParams.fiscalYear &&
        importIdToUse !== matchParams.importId &&
        firstModuleFromProject
    ) {
        const to = hydrateRoute(match.path, {
            ...matchParams,
            fiscalYear,
            importId: importIdToUse,
            firstModuleFromProject,
        });

        if (to !== match.url && !to.match(/\*$/)) {
            return urlRedirectLink(to);
        }
    }
};

export const repoRedirectValidations = (params) => {
    const {
        redirect,
        fiscalYear,
        importId,
        fiscalYears,
        appContext,
        match,
        matchParams,
        importIdToUse,
        firstModuleFromProject,
        section,
        fileType,
        queryStatus,
        setAccount,
        project,
        locale,
        history,
        proxy,
        projectId,
    } = params || {};

    if (redirect) {
        return redirect;
    }

    if (match?.params?.urlRedir && (!queryStatus || queryStatus?.loading)) {
        return <LoadingPage />;
    }

    if (fiscalYear && fiscalYear !== "0000" && match?.params?.urlRedir) {
        return setAccount(project, locale, history, proxy, params);
    }

    if (!section) {
        return urlRedirectLink(
            `${locale ? `/${locale}` : "/en"}/${projectId}/0000/full/repository/activity`,
        );
    }

    if (!projectId) {
        return urlRedirectLink(`${locale ? `/${locale}` : ""}/`);
    }

    if (!fiscalYear && !importId && !fiscalYears.length) {
        return urlRedirectLink(
            `${locale ? `/${locale}` : "/en"}/${projectId}/0000/full/repository/activity`,
        );
    }

    if (
        fiscalYear &&
        importId &&
        fiscalYears.length &&
        appContext === "repository" &&
        !(match?.url || "").match("\\d+/\\d+/\\d+/repository") &&
        !(match?.url || "").match("\\d+/\\d+/full/repository")
    ) {
        return urlRedirectLink(
            `${locale ? `/${locale}` : "/en"}/${projectId}/${fiscalYear}/${importId}/repository/${section}${fileType ? "/" + fileType : ""}`,
        );
    }

    if (fiscalYear === "0000" && fiscalYears.length) {
        const to = hydrateRoute(match.path, {
            ...matchParams,
            fiscalYear: Math.max(...fiscalYears),
            importId: importIdToUse,
            firstModuleFromProject,
        });

        if (to !== match.url && !to.match(/\*$/)) {
            return urlRedirectLink(to);
        }
    }

    if (
        fiscalYear &&
        importIdToUse &&
        !isNaN(Number(matchParams.fiscalYear)) &&
        !isNaN(Number(matchParams.importId)) &&
        fiscalYear !== matchParams.fiscalYear &&
        importIdToUse !== matchParams.importId &&
        firstModuleFromProject
    ) {
        const to = hydrateRoute(match.path, {
            ...matchParams,
            fiscalYear,
            importId: importIdToUse,
            firstModuleFromProject,
        });

        if (to !== match.url && !to.match(/\*$/)) {
            return urlRedirectLink(to);
        }
    }
};

export const controllerQueries = (args, userModulesByProject) => {
    const queries = filteredQueriesByModules(userModulesByProject);
    const deepCopyQueries = JSON.parse(JSON.stringify(queries));
    if (deepCopyQueries) {
        //needed to change arguments to the respective value
        deepCopyQueries.forEach((query) =>
            Object.keys(query.args).forEach((k) =>
                query.args[k] ? query.args[k] : (query.args[k] = args[k] || query.args[k]),
            ),
        );
    }

    const allQueries = [
        {
            resource: "menu_organizations_projects",

            body: "id,name,typeEntity,nestedAccounts{id,name,typeEntity}",
            forceRefresh: true,
        },
        {
            resource: "organization_projects_by_projectId",
            args: {
                projectId: args.projectId,
            },
            body: "id,name,maxFiscalYear,fiscalYears,calendarYears,mosaicThemeConfig,projects{id,name,fiscalYears,status,taxRegistrationNumber,active,projectExpired,metadata,mosaicThemeConfig,modules{navigation_by_import_id,name,default_route,default_module}},organizationExpired, organizationActive, maxFiscalYear",
            forceRefresh: true,
        },
        {
            resource: "get_limit_export",
        },
        ...deepCopyQueries,
    ];
    if (userModulesByProject && userModulesByProject.includes("merge_collisions")) {
        allQueries.push({
            resource: "repository_status",
            args: {
                projectId: args.projectId,
                fiscalYear: args.fiscalYear,
            },
            body: "repoStatus,fiscalYear,fileType,autoMerge",
        });
    }

    return allQueries;
};

export const generateChildren = ({
    displayComponents,
    fetchResults,
    fetchStatus,
    routeQueries,
    props,
    params,
    i18n,
    locale,
    modules,
    fetch,
    pushModal,
    reload,
    onClickConfigurator,
}) => {
    return displayComponents.map((c, index) => {
        const Component = c.component;
        const componentParsedProps = mapProperties(
            c.props,
            fetchResults,
            fetchStatus,
            routeQueries,
            props,
            params,
            i18n,
            locale,
        );

        const componentProps = {
            ...componentParsedProps,
            modules,
        };

        if (componentProps && componentProps.onClickPushModal) {
            onClickConfigurator(componentProps, params, pushModal, i18n, reload);
        }

        return (
            <Component
                key={index}
                modifiers={c.modifiers}
                {...componentProps}
                activity={fetch.activity}
            />
        );
    });
};

export const onClickConfiguratorApp = (componentProps, params, pushModal, i18n, reload) => {
    const { view, title } = componentProps.onClickPushModal;
    componentProps.onRowClickCustom = (e) => {
        const { row } = e;
        pushModal({
            title: i18n`${title}`,
            data: {
                projectId: params.projectId,
                ...row,
            },
            args: { ...params, ...row },
            view: `${view}Form`,
        })
            .then(() => reload && reload())
            .catch(() => null);
    };
};

export const onClickConfiguratorRepository = (componentProps, params, pushModal, i18n, reload) => {
    const { view, title } = componentProps.onClickPushModal;
    componentProps.onClick = (e) => {
        e.originalEvent.preventDefault();
        e.originalEvent.stopPropagation();
        const data = e.target.value || {};
        pushModal({
            title: i18n`${title}`,
            data: {
                projectId: params.projectId,
                ...data,
            },
            args: { ...params, ...data },
            view: `${view}Form`,
        })
            .then(() => reload && reload())
            .catch(() => null);
    };
};

export const isPageLoading = (status, activity) => {
    return (
        activity ||
        activity === null ||
        Object.keys(status).some((queryKey) => {
            return status[queryKey].loading === true;
        })
    );
};

export const GlobalPageLayout = ({
    styles,
    globalLayoutProps,
    modules,
    headerProps,
    headerComponentsMapper,
    children,
    route,
    matchParams,
    fetch,
    isLoadingContent,
}) => {
    const { title, titleBarActions, ...restHeaderProps } = headerProps;
    return (
        <GlobalLayout {...globalLayoutProps}>
                <RepositoryStatus modules={modules} />
                <SovosPageLayout
                    pageTitle={title?.toString() || ""}
                    titleBarActions={titleBarActions}
                >
                    <SovosPageContentGeneric
                        sx={{ padding: "0 !important", marginLeft: "24px", marginRight: "24px" }}
                    >
                        <Connect to={["search", "downloading"]}>
                            {({ downloading }) => (
                                <FileInformationSelection
                                    {...restHeaderProps}
                                    downloading={downloading}
                                    headerComponents={
                                        Array.isArray(headerProps.headerComponents)
                                            ? headerProps.headerComponents.map(
                                                  headerComponentsMapper(downloading),
                                              )
                                            : null
                                    }
                                />
                            )}
                        </Connect>
                        {isLoadingContent(fetch) ? (
                            <SovosBox
                                sx={{
                                    flex: 1,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <SovosCircularProgress aria-label="Loading" />
                            </SovosBox>
                        ) : (
                            <>
                                {fetch.activity && (
                                    <LoadingIndicator
                                        className={`${styles["loading-indicator"]}`}
                                    />
                                )}
                                {children}
                                {route.routes && route.routes.length > 1 && (
                                    <MainTabs
                                        className={styles["tabs"]}
                                        routes={route.routes}
                                        params={matchParams}
                                    />
                                )}
                                {renderRoutes(route.routes)}
                            </>
                        )}
                    </SovosPageContentGeneric>
                </SovosPageLayout>
        </GlobalLayout>
    );
};

export const useControllerInitialization = (props) => {
    const { pushModal, modules, user, fetch, menu, match, route, location, history, reload } =
        props;
    const { params: matchParams } = match || {};
    const { projectId, modulePrefix, locale = "en" } = matchParams;
    const { results: fetchResults, status: fetchStatus } = fetch || {};

    const defaultContext = (match?.url || "").match("/repository/") ? "repository" : "";
    const [appContext, setAppContext] = useState(defaultContext);
    const auth = useAuth();

    useEffect(() => {
        if ((match?.url || "").match("/repository/")) {
            setAppContext("repository");
        } else {
            setAppContext("");
        }
    }, [match]);

    const userInformation = userSessionInfo(user);
    const i18n = I18n.use(locale);

    return {
        // Original props
        pushModal,
        modules,
        user,
        fetch,
        menu,
        match,
        route,
        location,
        history,
        reload,
        // Extracted values
        matchParams,
        projectId,
        modulePrefix,
        locale,
        fetchResults,
        fetchStatus,
        // State and hooks
        appContext,
        setAppContext,
        auth,
        userInformation,
        i18n,
    };
};

export const organizationAndProjectSelection = ({
    fetchResults,
    fetchStatus,
    component: Component,
    matchParams,
    props,
    i18n,
    locale,
    fiscalYear,
    importId,
    projectId,
}) => {
    const { menuOrganizationProject = [] } = mapProperties(
        {
            menuOrganizationProject: "query(0).list",
        },
        fetchResults,
        fetchStatus,
        Component.queries(matchParams),
        props,
        matchParams,
        i18n,
        locale,
    );

    const { organizationProjects = {}, queryStatus } = mapProperties(
        {
            organizationProjects: "query(1)",
            queryStatus: "status(1)",
        },
        fetchResults,
        fetchStatus,
        Component.queries(matchParams),
        props,
        matchParams,
        i18n,
        locale,
    );

    const project = organizationProjects
        ? (organizationProjects.projects || []).find(({ id }) => id === projectId) || {
              name: "",
          }
        : { name: "" };

    const { fiscalYears: projectFiscalYears } = project || {};

    const fiscalYears = Object.keys(projectFiscalYears || []);

    if (!fiscalYear && project && projectFiscalYears) {
        fiscalYear = fiscalYears.length > 0 ? Math.max(...fiscalYears) : "";
    }

    const fiscalYearsWithImportIds = projectFiscalYears || {};
    const importIdsFromUrlFiscalYear = fiscalYearsWithImportIds[fiscalYear];

    if (!importId && importIdsFromUrlFiscalYear && importIdsFromUrlFiscalYear.length) {
        const [maxImportId] = importIdsFromUrlFiscalYear;
        importId = maxImportId?.id;
    }

    return {
        menuOrganizationProject,
        organizationProjects,
        queryStatus,
        projectFiscalYears,
        project,
        fiscalYears,
        fiscalYearsWithImportIds,
        importIdsFromUrlFiscalYear,
        fiscalYear,
        importId,
    };
};

export const buildGenericMenu = (
    modules,
    fetchResults,
    locale,
    fiscalYear,
    projectId,
    importId,
    project,
    location,
    matchParams,
    route,
) => {
    const queriesForMenu = filteredQueriesByModulesForMenu(modules);
    const navData = mapPropertiesForMenu(
        queriesForMenu,
        fetchResults,
        locale,
        fiscalYear,
        projectId,
        importId,
    );

    const firstModuleFromProject = getFirstModuleOfArray(modules);
    const moduleConfigs = project
        ? (project.modules || []).find(({ name }) => name === firstModuleFromProject)
        : undefined;
    const importIdToUse =
        moduleConfigs && moduleConfigs.navigation_by_import_id ? importId : "full";

    const params = {
        ...(parse(location.search) || {}),
        ...(matchParams || {}),
    };

    const routeQueries = (route.queries && route.queries(params)) || [];

    return { navData, importIdToUse, routeQueries, params, firstModuleFromProject };
};

export const buildDisplayComponents = (route, getLayout) => {
    let displayComponents = [];

    displayComponents.push(...route.components);

    if (getLayout.length > 0 && route && route.isOverview) {
        displayComponents.push(...getLayout);
    }

    return displayComponents;
};

export const buildHeaderComponents = (
    route,
    fetchResults,
    fetchStatus,
    routeQueries,
    props,
    params,
    i18n,
    locale,
) => {
    return Array.isArray(route?.headerComponents)
        ? route.headerComponents.map((headerProperties) => {
              const component = headerProperties.component;
              const headerComponentParsedProps = mapProperties(
                  headerProperties.props,
                  fetchResults,
                  fetchStatus,
                  routeQueries,
                  props,
                  params,
                  i18n,
                  locale,
              );
              return { Component: component, props: headerComponentParsedProps };
          })
        : [];
};

export const headerTitle = (
    route,
    fetchResults,
    fetchStatus,
    routeQueries,
    props,
    params,
    i18n,
    locale,
    fiscalYear,
    importId,
) => {
    return mapProperties(
        { title: route.title },
        fetchResults,
        fetchStatus,
        routeQueries,
        props,
        { ...params, fiscalYear, importId },
        i18n,
        locale,
    ).title;
};

export const getDownloadableQueries = (matchRoutes, route, location, params) => {
    const branch = matchRoutes([route, ...(route.routes || [])], location.pathname);

    const branchQueries = branch.reduce((allQueries, { route }) => {
        const innerQueries = route.queries ? route.queries(params) : [];
        allQueries = [...innerQueries];
        return allQueries;
    }, []);

    const downloadableQueries = branchQueries?.filter(({ downloadable }) => downloadable);

    return downloadableQueries;
};

export const generateNavigation = ({
    modules,
    asideRepositoryNavigationByModule,
    route,
    fetchResults,
    fetchStatus,
    component: Component,
    params,
    fiscalYear,
    importId,
    props,
    navData,
    i18n,
    locale,
}) => {
    const repositoryNavigation = filteredNavigationByModulesForNestedLinks(
        modules || [],
        asideRepositoryNavigationByModule,
    );

    const _navigation = (route.navigation || []).map((item) => {
        if (item?.name === "label(Repository)") {
            delete item.to;
            item.navigation = [...repositoryNavigation];
        }

        return item;
    });

    return mapProperties(
        { navigation: _navigation },
        fetchResults,
        fetchStatus,
        Component.queries({ ...params, fiscalYear, importId }),
        {
            ...props,
            ...navData,
        },
        { ...params, fiscalYear, importId },
        i18n,
        locale,
    );
};

export const buildNavProps = (
    buildStaticLinks,
    navigation,
    history,
    matchParams,
    fiscalYear,
    importId,
    i18n,
    menuOrganizationProject,
    projectId,
    cleanPropertiesNestedInMenu,
    locale,
    proxy,
    params,
    userInformation,
) => {
    const staticLinks = buildStaticLinks(
        navigation,
        history,
        { ...matchParams, fiscalYear, importId },
        i18n,
    );

    const organizationSelectedInMenu = (menuOrganizationProject || []).find(({ nestedAccounts }) =>
        (nestedAccounts || []).some(({ id }) => id === projectId),
    );

    const {
        accounts: fullOrganizationsWithProjects,
        selectedAccount: selectedOrganizationWithProjects,
    } = cleanPropertiesNestedInMenu(menuOrganizationProject, organizationSelectedInMenu);

    const navProps = BuildSovosNavProps(
        undefined,
        fullOrganizationsWithProjects,
        selectedOrganizationWithProjects,
        { locale, history, proxy, params: { ...params, fiscalYear, importId } },
        userInformation,
        staticLinks || [],
        projectId,
    );

    return { navProps, staticLinks };
};
